import React from 'react';
import { Box, Container, Typography, Link, useMediaQuery, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box component="footer" 
         sx={{ 
           mt: 'auto',
           py: { xs: 1, sm: 3 }, 
           borderTop: '1px solid rgba(0, 0, 0, 0.1)',
           backgroundColor: '#f8f9fa'
         }}>
      <Container maxWidth="lg">
        {isMobile ? (
          // Mobile: Only show copyright
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              © {new Date().getFullYear()} Magna Legal Services
            </Typography>
          </Box>
        ) : (
          // Desktop: Full footer
          <Box sx={{ 
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: { xs: 2, md: 3 }
          }}>
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'row',
              justifyContent: 'center', 
              gap: { xs: 2, sm: 3 },
              flexWrap: 'wrap',
              order: { xs: 2, md: 1 }
            }}>
              <Link href="https://magnals.com/about-us/" 
                    color="secondary" 
                    underline="none"
                    sx={{ 
                      textTransform: 'uppercase', 
                      fontWeight: 500, 
                      letterSpacing: '0.5px',
                      transition: 'color 0.3s ease',
                      fontSize: { xs: '0.85rem', sm: 'inherit' },
                      padding: { xs: '0.5rem 0.25rem', sm: '0' },
                      '&:hover': {
                        color: 'primary.main'
                      }
                    }}>
                About
              </Link>
              <Link href="https://magnals.com/contact-magna-legal-services/" 
                    color="secondary" 
                    underline="none"
                    sx={{ 
                      textTransform: 'uppercase', 
                      fontWeight: 500, 
                      letterSpacing: '0.5px',
                      transition: 'color 0.3s ease',
                      fontSize: { xs: '0.85rem', sm: 'inherit' },
                      padding: { xs: '0.5rem 0.25rem', sm: '0' },
                      '&:hover': {
                        color: 'primary.main'
                      }
                    }}>
                Contact
              </Link>
              <Link href="https://magnals.com/privacy-policy/" 
                    color="secondary" 
                    underline="none"
                    sx={{ 
                      textTransform: 'uppercase', 
                      fontWeight: 500, 
                      letterSpacing: '0.5px',
                      transition: 'color 0.3s ease',
                      fontSize: { xs: '0.85rem', sm: 'inherit' },
                      padding: { xs: '0.5rem 0.25rem', sm: '0' },
                      '&:hover': {
                        color: 'primary.main'
                      }
                    }}>
                Privacy
              </Link>
              <Link component={RouterLink}
                    to="/help" 
                    color="secondary" 
                    underline="none"
                    sx={{ 
                      textTransform: 'uppercase', 
                      fontWeight: 500, 
                      letterSpacing: '0.5px',
                      transition: 'color 0.3s ease',
                      fontSize: { xs: '0.85rem', sm: 'inherit' },
                      padding: { xs: '0.5rem 0.25rem', sm: '0' },
                      '&:hover': {
                        color: 'primary.main'
                      }
                    }}>
                How to Use This Site
              </Link>
            </Box>
            
            <Typography 
              variant="body2" 
              color="text.secondary"
              sx={{ 
                order: { xs: 1, md: 2 },
                textAlign: { xs: 'center', md: 'right' }
              }}
            >
              © {new Date().getFullYear()} Magna Legal Services
            </Typography>
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default Footer;